/** A colour mode the dashboard can be shown in; system follows the operating system's. */
export type ColorMode = "light" | "dark" | "system"

const MODES: ColorMode[] = ["light", "dark", "system"]

/** The mode the dashboard opens in: one named in the url, else the last one chosen, else dark. */
export function initialColorMode(fromUrl: string | null, remembered: unknown): ColorMode {
  for (const candidate of [fromUrl, remembered]) {
    if (isColorMode(candidate)) {
      return candidate
    }
  }

  return "dark"
}

function isColorMode(value: unknown): value is ColorMode {
  return MODES.includes(value as ColorMode)
}
